import { ResponsiveBar } from '@nivo/bar';
import { ResponsiveLine } from '@nivo/line';
import { ResponsiveScatterPlot } from '@nivo/scatterplot';
import { red, yellow, green } from '@mui/material/colors';
import defColors from 'utils/defColors';
import { dashboardTheme } from 'utils/nivoConfig';

export const defaultChartProps = {
    theme: dashboardTheme,
    colors: defColors.trafficColors,
    margin: { top: 150, right: 150, bottom: 160, left: 150 },
    isInteractive: false,
    enableGridY: false,
    enableGridX: false,
    axisLeft: {
        tickSize: 0,
        tickValues: [0, 50, 100, 150, 200, 250],
        tickPadding: 5,
        legend: '교통량',        
        legendPosition: 'middle',
        legendOffset: -80,        
    },
    axisBottom: {
        tickSize: 0,
        tickPadding: 15,
        legend: '시간대',        
        legendPosition: 'end',
        legendOffset: 60,
    }    
}

export const getChartComponent = (chartDef, chartData) => {
    const { chartType, converter } = chartDef

    const getChart = () => {
        switch (chartType) {
            case "bar":
                return getTrafficBar(converter(chartData));
            case "area":
                return getTrafficLine(converter(chartData));
            case "scatterPlot":
                return getTrafficScatterPlot(converter(chartData));
            default:
                break;
        }
    }

    return (
        getChart()
    )
}

const getTrafficBar = (chartData) => {
    return (
        <ResponsiveBar
            {...defaultChartProps}
            data={chartData}
            keys={['정체', '지체', '원활']}
            indexBy="date"
            layout="vertical"
            axisTop={null}
            axisRight={null}
            //axisBottom={null}
            labelSkipHeight={20}
            legends={[
                {
                    dataFrom: 'keys',
                    anchor: 'bottom',
                    direction: 'row',
                    justify: false,
                    translateX: 0,
                    translateY: 100,
                    itemsSpacing: 100,
                    itemWidth: 100,
                    itemHeight: 30,
                    itemDirection: 'left-to-right',
                    itemOpacity: 1,
                    symbolSize: 20,
                }
            ]}
            padding={0.3}
        />
    )
}

const getTrafficLine = (chartData) => {
    return (
        <ResponsiveLine
            {...defaultChartProps}
            data={chartData}
            enablePoints={false}
            enableArea={true}
            areaOpacity={0.9}
            yScale={{
                stacked: true,
                type: 'linear'
            }}
            legends={[
                {
                    anchor: 'bottom',
                    direction: 'row',
                    justify: false,
                    translateX: 0,
                    translateY: 100,
                    itemsSpacing: 100,
                    itemWidth: 100,
                    itemHeight: 30,
                    itemDirection: 'left-to-right',
                    itemOpacity: 1,
                    symbolSize: 20,
                }
            ]}
        />
    )
}

const getTrafficScatterPlot = (chartData) => {
    return (
        <ResponsiveScatterPlot
            {...{
                theme: dashboardTheme,
                colors: [red[500], yellow[700], green[700]],
                margin: { top: 150, right: 150, bottom: 150, left: 150 },
                isInteractive: false,
                enableGridY: false,
                enableGridX: false,
            }}
            data={chartData}
            xScale={{ type: 'linear', min: 0, max: 'auto' }}
            xFormat=">-.2f"
            yScale={{ type: 'linear', min: 0, max: 'auto' }}
            yFormat=">-.2f"
            // blendMode="multiply"
            axisBottom={{
                orient: 'bottom',
                tickSize: 0,
                legend: '일자',
                legendPosition: 'middle',
                legendOffset: 50
            }}
            axisLeft={{
                orient: 'left',
                tickSize: 0,
                legend: '시간',
                legendPosition: 'middle',
                legendOffset: -60
            }}
            legends={[
                {
                    anchor: 'bottom',
                    direction: 'row',
                    justify: false,
                    translateX: 0,
                    translateY: 130,
                    itemsSpacing: 100,
                    itemWidth: 100,
                    itemHeight: 30,
                    itemDirection: 'left-to-right',
                    itemOpacity: 1,
                    symbolSize: 20,
                }
            ]}
        />
    )
}